import { Capacitor, registerPlugin } from "@capacitor/core";

const NativeAuthStorage = registerPlugin("NativeAuthStorage");
const ACCESS_KEY = "wgi_tracker_native_access_token";
const REFRESH_KEY = "wgi_tracker_native_refresh_token";
let tokens = null;
let loading = null;
let generation = 0;
let writes = Promise.resolve();

export function nativeAuthGeneration() { return generation; }

export function isNativeApp() {
  return Capacitor.isNativePlatform() && ["android", "ios"].includes(Capacitor.getPlatform());
}

function clearLegacyTokens() {
  window.localStorage.removeItem(ACCESS_KEY);
  window.localStorage.removeItem(REFRESH_KEY);
}

export async function getNativeAuthTokens() {
  if (!isNativeApp()) return {};
  if (tokens) return tokens;
  if (!loading) {
    const currentGeneration = generation;
    loading = (async () => {
      const saved = await NativeAuthStorage.get();
      let result = saved.value ? JSON.parse(saved.value) : {};
      if (!saved.value) {
        result = {
          access_token: window.localStorage.getItem(ACCESS_KEY) || "",
          refresh_token: window.localStorage.getItem(REFRESH_KEY) || "",
        };
        if (result.access_token || result.refresh_token) {
          await NativeAuthStorage.set({ value: JSON.stringify(result) });
        }
      }
      clearLegacyTokens();
      if (currentGeneration === generation) tokens = result;
      return currentGeneration === generation ? result : (tokens || {});
    })().finally(() => { loading = null; });
  }
  return loading;
}

export async function storeNativeAuthTokens(data, expectedGeneration) {
  if (!isNativeApp() || !data) return;
  if (loading) await loading.catch(() => {});
  if (expectedGeneration !== undefined && expectedGeneration !== generation) {
    throw new Error("Login session changed");
  }
  generation += 1;
  const writeGeneration = generation;
  tokens = { access_token: data.access_token || "", refresh_token: data.refresh_token || "" };
  const value = JSON.stringify(tokens);
  writes = writes.catch(() => {}).then(() => NativeAuthStorage.set({ value }));
  try {
    await writes;
  } catch (error) {
    if (writeGeneration === generation) tokens = null;
    throw error;
  }
  clearLegacyTokens();
}

export async function clearNativeAuthTokens() {
  if (!isNativeApp()) return;
  generation += 1;
  tokens = {};
  clearLegacyTokens();
  if (loading) await loading.catch(() => {});
  writes = writes.catch(() => {}).then(() => NativeAuthStorage.clear());
  await writes;
}
